import A404 from "../image/404.webp";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="A404044">
      <div className="A404_section">
        <img src={A404} alt="404 img" />
        <h1>Page Not Found</h1>

        <div className="errpage_link">
          <button
            onClick={() => navigate("/")}
            className="primary-landing-main-btn"
          >
            Go Home{" "}
            <span className="mx-2 right-arr">
              <i className="fa-solid fa-arrow-right"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;
